import React from 'react'
import { Pill } from '@scentregroup/ui'
import { Stack } from '@hub/stack'
import { Box } from '@hub/box'
import { IFacet, IFacetSelections, IFacetOption } from '../../types/facets'
import { onSelectById } from '../faceted-filters/faceted-filters-utils'
import { isFacetOptionSelected } from '../../lib/facets'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'
export interface IItem {
  label: string
  value: string
}

export interface IFilterPillsProps {
  items: IItem[]
  onRemove: (selected: string) => void
}

const FilterPills: React.FC<React.PropsWithChildren<IFilterPillsProps>> = ({
  items,
  onRemove,
}) => {
  return (
    <>
      {items.map(item => (
        <Box
          key={item.value}
          sx={{ paddingBottom: 'spacing-sm', paddingRight: 'spacing-sm' }}
        >
          <Pill onRemove={() => onRemove(item.value)}>{item.label}</Pill>
        </Box>
      ))}
    </>
  )
}

export interface IFacetFilteredPillsProps {
  productTypes?: string[]
  productTypeSelections: string[]
  onChangeProductTypeSelections(productTypes: string[]): void
  facets: IFacet[]
  facetSelections: IFacetSelections
  onChangeFacetSelections(facetSelections: IFacetSelections): void
}

const FacetFilteredPills: React.FC<
  React.PropsWithChildren<IFacetFilteredPillsProps>
> = ({
  productTypes,
  facets,
  productTypeSelections,
  onChangeProductTypeSelections,
  facetSelections,
  onChangeFacetSelections,
}) => {
  return (
    <Box sx={{ paddingBottom: 'spacing-md' }}>
      <Stack
        direction="row"
        sx={{ flexWrap: 'wrap' }}
        shouldWrapChildren={false}
      >
        {/* product types filters */}
        {productTypes && productTypes.length > 0 && (
          <FilterPills
            items={productTypes
              .filter(
                productType =>
                  productTypeSelections.find(o => o === productType) !==
                  undefined
              )
              .map(option => ({
                label: option,
                value: option,
              }))}
            onRemove={(selected: string) => {
              onChangeProductTypeSelections(
                productTypeSelections.filter(option => option !== selected)
              )
              trackMkpEvents.unselected(
                labels.createRemovedFilterFacetPills('Type', selected)
              )
            }}
          />
        )}
        {/* facet filters */}
        {facets.map((facet: IFacet) => {
          const { id, options, title } = facet
          return (
            <FilterPills
              key={id}
              items={options
                .filter((option: IFacetOption) =>
                  isFacetOptionSelected(facetSelections, id, option.id)
                )
                .map((option: IFacetOption) => ({
                  label: option.group
                    ? option.group + ' ' + option.label
                    : option.label,
                  value: option.id,
                }))}
              onRemove={(selected: string) => {
                const selections = options
                  .filter((option: IFacetOption) =>
                    isFacetOptionSelected(facetSelections, id, option.id)
                  )
                  .map((option: IFacetOption) => option.id)
                onSelectById(
                  id,
                  selections.filter(option => option !== selected),
                  facets,
                  facetSelections,
                  onChangeFacetSelections
                )
                trackMkpEvents.unselected(
                  labels.createRemovedFilterFacetPills(title, selected)
                )
              }}
            />
          )
        })}
      </Stack>
    </Box>
  )
}

export default FacetFilteredPills
